import EditController from "csi/action/EditController";
import { routerStore } from "csi/state/rootStore";
import EditSnapshotTemplateDialog from "csi/threeD/snapshotTemplates/dialogs/EditSnapshotTemplateDialog";
import SnapshotTemplateDialogStore from "csi/threeD/snapshotTemplates/dialogs/SnapshotTemplateDialogStore";
import { SnapshotTemplateId } from "csi/threeD/snapshotTemplates/snapshotUtils";
import xml from "csi/xml";
import declare from "dojo/_base/declare";

const EditSnapshotTemplate = declare(EditController, {
	/**
	 * @override
	 * Open React dialog
	 */
	preProcess(): void {
		const node = this.getNode();
		const {
			[xml.ATTR_TYPE]: type,
			$URL: url,
		  } = node;

		const onSave = async (jsonResponse): Promise<void> => {
			this.processReact(jsonResponse);
		};	

		const onCancel = (): void => {
			this.onCancelReactDialog();
		};
		
		const store = new SnapshotTemplateDialogStore(onCancel, onSave, this.m_writer, type as SnapshotTemplateId);

		this.useReactDialog(routerStore.openDialog(EditSnapshotTemplateDialog, {
			store,
			selectedTemplate: url,
		}));
	},
});

export = EditSnapshotTemplate;